import { Box } from '@mui/material';
import { MetricRecordCaptureParameters } from '../../views/metric_collection/MetricCollectionDataManagement';
import QuantitativeMetricRecordGrid from './quantitative/QuantitativeMetricRecordGrid';
import QualitativeMetricRecordGrid from './qualitative/QualitativeMetricRecordGrid';
import { MetricRecordEntitiesMap } from '../../graphql/services/metric_record.service';

interface MetricCollectionHubProps {
  capture_parameters: MetricRecordCaptureParameters;
  entities_map: MetricRecordEntitiesMap;
}

/**
 * Wrapper component of metric record capturing functionality of various types.
 * @param {MetricRecordCaptureParameters} capture_parameters Parameters of metric record capturing to be used by children.
 * @param {MetricRecordEntitiesMap} entities_map List of Metric Record field options to be used by children.
 * @returns {JSX.Element}
 */
const MetricCollectionHub = ({ capture_parameters, entities_map }: MetricCollectionHubProps) => {
  return (
    <Box className={'div-metrics-hub'} sx={{ px: 0.5, flexGrow: 1 }}>
      {capture_parameters.metric && capture_parameters.is_quantitative === true ? (
        <QuantitativeMetricRecordGrid
          capture_parameters={capture_parameters}
          entities_map={entities_map}
        />
      ) : (
        <QualitativeMetricRecordGrid
          capture_parameters={capture_parameters}
          entities_map={entities_map}
        />
      )}
    </Box>
  );
};

export default MetricCollectionHub;
